import { createSlice } from "@reduxjs/toolkit";

const initialListingsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  listingForEdit: undefined,
  lastError: null,
  queryParams: {},
  filters: {},
  searchColumns: [
    "name",
    "email",
    "number",
    "agent_sip_id",
    "calls_offered",
    "calls_answered",
    "calls_answered_percent",
    "missed_calls",
    "missed_calls_percent",
    "total_talk_time",
    "avg_handling_time",
    "avg_time_to_answer",
    "avg_hold_time",
    "total_logged_in_time",
    "available_time",
    "total_idle_time",
    "total_break_duration",
  ],
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const agentCallInsightsSlice = createSlice({
  name: "agentCallInsightsSlice",
  initialState: { ...initialListingsState },
  extraReducers: (builder) => {
    builder.addCase("[Auth] Logout Action", (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase("ClearMainFilters", (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
      state.searchColumns = [
        "name",
        "email",
        "number",
        "agent_sip_id",
        "calls_offered",
        "calls_answered",
        "calls_answered_percent",
        "missed_calls",
        "missed_calls_percent",
        "total_talk_time",
        "avg_handling_time",
        "avg_time_to_answer",
        "avg_hold_time",
        "total_logged_in_time",
        "available_time",
        "total_idle_time",
        "total_break_duration",
      ];

      return state;
    });
  },
  reducers: {
    reset: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
      state.searchColumns = [
        "name",
        "email",
        "number",
        "agent_sip_id",
        "calls_offered",
        "calls_answered",
        "calls_answered_percent",
        "missed_calls",
        "missed_calls_percent",
        "total_talk_time",
        "avg_handling_time",
        "avg_time_to_answer",
        "avg_hold_time",
        "total_logged_in_time",
        "available_time",
        "total_idle_time",
        "total_break_duration",
      ];
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    listingFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingForEdit = action.payload.listingForEdit;
      state.error = null;
    },

    listingsFetched: (state, action) => {
      var { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      if (action.payload["queryParams"]) {
        state.queryParams = action.payload["queryParams"];
      }
    },
    setFilters: (state, action) => {
      state.listLoading = false;
      if (action.payload["filters"]) {
        state.filters = { ...action.payload["filters"] };
      }
    },

    setSearchColumns: (state, action) => {
      if (action.payload["searchColumns"]) {
        state.searchColumns = { ...action.payload["searchColumns"] };
      }
    },
  },
});
